export default function formatDate(dateInput) {
    // Handle null/undefined
    if (!dateInput) {
        return 'Invalid date';
    }

    let dateObj;

    // If it's already in DD.MM.YYYY format, parse it
    if (typeof dateInput === 'string' && /^\d{2}\.\d{2}\.\d{4}$/.test(dateInput)) {
        const parts = dateInput.split('.');
        dateObj = new Date(parts[2], parts[1] - 1, parts[0]);
    }
    // Handle number (timestamp in milliseconds or seconds)
    else if (typeof dateInput === 'number') {
        // If the number is less than a reasonable timestamp (before year 2100 in seconds),
        // it's likely seconds instead of milliseconds
        if (dateInput < 4102444800) {
            dateObj = new Date(dateInput * 1000);
        } else {
            dateObj = new Date(dateInput);
        }
    } else {
        // Handle ISO string or other formats
        dateObj = new Date(dateInput);
    }

    // Validate the date
    if (isNaN(dateObj.getTime())) {
        console.error('Invalid date input:', dateInput, 'Type:', typeof dateInput);
        return 'Invalid date';
    }

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${day}.${month}.${year}`;
}